module.exports = __webpack_public_path__ + "static/media/w-1.ba112434.jpg";